import { render, staticRenderFns } from "./workout-plans.vue?vue&type=template&id=02631a21&"
import script from "./workout-plans.vue?vue&type=script&lang=js&"
export * from "./workout-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports